import styled from 'styled-components/macro';
import { color, ColorProps } from 'styled-system';
import { Rotate } from '../Animations';
import { Button } from './';
import { ReactComponent as LoadingIcon } from '../../Assets/Icons/loading.svg';
import { MouseEventHandler } from 'react';

type StyledModalButtonProps = ColorProps;

const StyledModalButton = styled.button<StyledModalButtonProps>`
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  margin: 0;
  font-family: ${(props) => props.theme.fontButton};
  font-size: 1.4rem;
  line-height: 35px;
  color: #fff;
  text-align: center;
  text-decoration: none;
  background-color: ${(props) => props.theme.colors.buttons.primary.backgroundColor};
  border: none;
  border-radius: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 35px;
  width: 100%;
  ${(props) => (!props.disabled ? 'cursor: pointer;' : 'cursor: not-allowed;')}
  transition: all 0.2s;
  ${color} :hover {
    transform: translateY(-1px);
  }

  :active {
    transform: translateY(1px);
  }

  &.focus-visible {
    outline: none;
    box-shadow: 0px 0px 0px 2px ${(props) => props.theme.highLightColor};
  }
`;

export interface ModalButtonProps extends React.ComponentProps<typeof StyledModalButton> {
  children: React.ReactNode;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  isLoading?: boolean;
  disabled?: boolean;
}

export const ModalButton = (props: ModalButtonProps) => {
  const { children, onClick, isLoading, disabled, ...rest } = props;
  return (
    <StyledModalButton onClick={onClick} disabled={disabled || isLoading} {...rest}>
      {children}{' '}
      {isLoading && (
        <Rotate width="16px" height="16px" verticalAlign="text-bottom">
          <LoadingIcon
            style={{
              width: '100%',
              height: '100%',
              verticalAlign: 'top',
            }}
          />
        </Rotate>
      )}
    </StyledModalButton>
  );
};

export const CancelButton = styled(Button)`
  background-color: ${(props) => props.theme.errorColor};
  margin: 0 auto;
  margin-bottom: 64px;

  @media screen and (max-width: 767px) {
    margin-top: -32px;
  }
`;
